import { yLoadAsyncScript } from '../../y/util';

let ace_promise: Promise<void> | undefined;

export function uiInitCodeEditor() {
    ace_promise ??= yLoadAsyncScript('https://cdnjs.cloudflare.com/ajax/libs/ace/1.43.3/ace.js');

    return ace_promise;
}
